import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { LinkParser } from '../LinkParser';
import { linkRegEx } from '../../utils';

import { TextButton } from '@xingternal/button';
import styles from './styles.css';

export type TruncatedTextProps = {
  children: string;
  limit: number;
};

const TruncatedText = ({ limit = 200, children: text }: TruncatedTextProps) => {
  const [isToggled, setIsToggled] = useState(false);
  const textIsLongEnough = text.length > limit + 20;
  const Links = text
    .split(linkRegEx)
    .filter((textItem) => linkRegEx.exec(textItem) !== null);
  // we have to detect which link has been cut due to truncation
  const cutLink: any = text
    .substr(0, limit)
    .split(linkRegEx)
    .filter((textItem) => linkRegEx.exec(textItem) !== null)
    .find((element) => !Links.includes(element));
  // and pass the full link, so the LinkParser can replace the truncated link with the correct one
  const completeLink = Links.find((link) => link?.includes(cutLink));

  return (
    <>
      <LinkParser completeLink={completeLink} cutLink={cutLink}>
        {isToggled || !textIsLongEnough ? text : text.substr(0, limit) + '... '}
      </LinkParser>
      {!isToggled && textIsLongEnough && (
        <TextButton
          size={'small'}
          fontWeight={'regular'}
          onClick={() => setIsToggled(true)}
          className={styles.button}
        >
          <FormattedMessage id="EP_READ_MORE_CTA" />
        </TextButton>
      )}
    </>
  );
};

export default TruncatedText;
